import { Link } from "react-router-dom";
import { ArrowRight, Calculator } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import sellerNetSheetImage from "@/assets/seller-net-sheet-hero.png";

const ConsumerSellerNetSheet = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section ref={ref} className="py-20 px-4">
      <div className="container mx-auto">
        <div className={`grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto transition-all duration-700 ${isVisible ? 'animate-fade-in' : 'opacity-0'}`}>
          {/* Image Section - desktop only (left column) */}
          <div className="hidden md:block md:order-1">
            <div className="relative rounded-xl overflow-hidden bg-gray-800/50 border border-gray-700">
              <img
                src={sellerNetSheetImage}
                alt="House with calculator - Seller Net Sheet Calculator"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#080c14]/60 to-transparent" />
            </div>
          </div>

          {/* Content Section */}
          <div className="order-1 md:order-2 text-center md:text-left">
            <div className="inline-flex items-center gap-2 bg-[#ffd700]/10 text-[#ffd700] px-4 py-2 rounded-full mb-6">
              <Calculator className="h-4 w-4" />
              <span className="text-sm font-medium">Free Tool</span>
            </div>
            
            <h2 className="text-4xl font-bold mb-4">
              Know Your Bottom Line
            </h2>

            {/* Image Section - mobile only (after heading) */}
            <div className="md:hidden mb-6">
              <div className="relative rounded-xl overflow-hidden bg-gray-800/50 border border-gray-700">
                <img
                  src={sellerNetSheetImage}
                  alt="House with calculator - Seller Net Sheet Calculator"
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#080c14]/60 to-transparent" />
              </div>
            </div>
            
            <p className="text-xl text-gray-300 mb-6">
              Calculate exactly what you'll walk away with after selling your home. 
              Our free Seller Net Sheet tool estimates your proceeds after mortgage 
              payoffs, commissions, and closing costs.
            </p>
            
            <ul className="text-gray-400 space-y-2 mb-8">
              <li className="flex items-center gap-2 justify-center md:justify-start">
                <span className="w-1.5 h-1.5 bg-[#ffd700] rounded-full" />
                Account for all closing costs
              </li>
              <li className="flex items-center gap-2 justify-center md:justify-start">
                <span className="w-1.5 h-1.5 bg-[#ffd700] rounded-full" />
                See your estimated net proceeds instantly
              </li>
              <li className="flex items-center gap-2 justify-center md:justify-start">
                <span className="w-1.5 h-1.5 bg-[#ffd700] rounded-full" />
                No sign-up required
              </li>
            </ul>

            <Button
              asChild
              size="lg"
              className="bg-[#ffd700] hover:bg-[#ffd700]/90 text-[#080c14] font-semibold"
            >
              <Link to="/seller-net-sheet">
                Calculate My Net
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsumerSellerNetSheet;
